/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import CustomTooltip from '../CustomTooltip/CustomTooltip'
import moment from 'moment'
import { Divider } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { getCampaignDetailsById } from 'src/services/campaignService';
import { getESPConnectionData } from 'src/services/emailAPIESPServices';
import type { appConfigs } from '../types/types'
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Image03Icon, HelpCircleIcon, ViewStrokeRounded } from '@hugeicons-pro/core-stroke-rounded';
import OutlineButton from '../MUICustomButton/OutlineButton'
import TemplatePreview from '../TemplatePreview/TemplatePreview'
import { API_REQUEST_FORMAT_MESSAGE, UNSUBSCRIBE_LEVELS } from 'src/constants/constant'


function CampaignSummary(): JSX.Element {

    // const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [campaignData, setCampaignData] = useState<any>({})
    const [previewContent, setPreviewContent] = useState<string>("");
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [espConnectionData, setEspConnectionData] = useState<any[]>([]);

    const storedAppConfig = localStorage.getItem("appConfigs");
    const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : []; // Default to an empty array if null

    const TemplateImagePublicURL = parsedAppConfig.find(
        (item) => item.configName === "TemplateImagePublicURL"
    )?.configValue;

    const navigate = useNavigate()

    const param = useParams();
 const [imageError, setImageError] = useState(false);
    const { id, type } = param;

    useEffect(() => {
        getESPConnectionData().then((res: any) => {
            if (res.status === 200 && res.data.result === 1) {
                setEspConnectionData(res.data.data);
            }
        }).catch((error: any) => console.log("Error fetching ESP connections:", error));
    }, [])

    useEffect(() => {
        fetchCampaingData()
    }, [id])

    const fetchCampaingData = async (): Promise<void> => {
        setIsDataLoading(true)
        try {
            const campaignId: any = id;
            if (campaignId === null) return;
            // setIsLoading(true)
            const res: any = await getCampaignDetailsById(campaignId);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (res.status === 200 && res.data.data.length > 0) {
                const campaign = res.data.data[0]; // Access the first brand in the array
                setCampaignData(campaign);
                const unsubscribeLevel = UNSUBSCRIBE_LEVELS.find(
                    (level) => Number(level.value) === Number(campaign.unsubscribeTypeId)
                );

                setCampaignData({
                    ...campaign,
                    unsubscribeLabel: unsubscribeLevel?.label ?? "Unknown",
                });
                setPreviewContent("content")
                // Fetch groups and then check for cooldown period

            }
        } catch (error) {
            console.error("Error fetching brand data:", error);
        } finally {
            setIsDataLoading(false)
            // setIsLoading(false)
        }
    }

    const handleBackClick = (): void => {
        navigate('/campaigns')
    }

useEffect(() => {
  setImageError(false);
}, [campaignData?.templateIdentifier]);

    return (
        
                <div className="flex justify-between items-center">
                    <div className="w-full">
                        <h1 className="text-2xl text-title font-semibold">Campaign ID: {campaignData.campaignId}</h1>
                        <div className='campaign-form-container'>
                            <div className="bg-white w-full">
                                <div className="flex flex-col items-center bg-gray-50 mb-[30px]">
                                    <svg height="70px" width="70px" viewBox="0 0 32 32" fill="#38b120">
                                        <path d="M16,0C7.164,0,0,7.164,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M13.52,23.383L6.158,16.02l2.828-2.828l4.533,4.535l9.617-9.617l2.828,2.828L13.52,23.383z" />
                                    </svg>
                                    <p className="font-semibold text-muted text-[1.5rem] mt-2">{type === 'add' ? 'Trigger email created successfully' : 'Trigger email updated successfully'}</p>
                                </div>
                                {
                                    isDataLoading ?
                                        <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :
                                        <React.Fragment>
                                            <div className="flex flex-row w-full ">
                                                {/* ✅ Left Section: Summary */}
                                                <div className="w-1/2 pr-[20px]">
                                                    <div className="mb-[10px] relative"> {/* Increased width from w-3/4 to w-[85%] */}
                                                        <div className="bg-[#f5f5f5] text-center text-16 font-semibold rounded-full p-[4px] text-muted w-full">
                                                            Summary
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="flex mt-[20px] mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Campaign ID</span>
                                                            <CustomTooltip title={campaignData.campaignId} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaignData.campaignId}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Campaign Name</span>
                                                            <CustomTooltip title={campaignData.name} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaignData.name}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Campaign Start Date</span>
                                                            <CustomTooltip title={moment(campaignData.startOn).format('MM/DD/YYYY')} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{moment(campaignData.startOn).format('MM/DD/YYYY')}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Campaign End Date</span>
                                                            <CustomTooltip title={moment(campaignData.endOn).format('MM/DD/YYYY')} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{moment(campaignData.endOn).format('MM/DD/YYYY')}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Brand</span>
                                                            <CustomTooltip title={campaignData.brandName} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaignData.brandName}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Group</span>
                                                            <CustomTooltip title={campaignData.groupName} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaignData.groupName}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Domain Name</span>
                                                            <CustomTooltip title={(() => { const match: any = espConnectionData.find((esp: any) => esp.id === Number(campaignData.espConnectionId)); return campaignData.espDomain ?? campaignData.espDomainName ?? match?.domain ?? match?.espDomainName ?? match?.connectionName ?? 'N/A'; })()} placement='bottom' arrow={false}>
                                                                <span className="text-muted w-1/2 truncate">
                                                                    {(() => { const match: any = espConnectionData.find((esp: any) => esp.id === Number(campaignData.espConnectionId)); return campaignData.espDomain ?? campaignData.espDomainName ?? match?.domain ?? match?.espDomainName ?? match?.connectionName ?? 'N/A'; })()}
                                                                </span>
                                                            </CustomTooltip>
                                                        </div>
                                                        {/* <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Unsubscribe Level</span>
                                                            <CustomTooltip title={campaignData.unsubscribeLabel} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaignData.unsubscribeLabel}</span></CustomTooltip>
                                                        </div> */}
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Template ID</span>
                                                            <CustomTooltip title={campaignData.templateId} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaignData.templateId}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Template Name</span>
                                                            <CustomTooltip title={campaignData.templateName} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaignData.templateName}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Client Campaign ID</span>
                                                            <CustomTooltip title={campaignData.clientCampaignId || 'N/A'} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaignData.clientCampaignId || 'N/A'}</span></CustomTooltip>
                                                        </div>
                                                        {/* <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Suppression List</span>
                                                            <CustomTooltip title={campaignData.suppressionListTitle} placement="bottom" arrow={false}>
                                                                <span className="text-muted w-1/2">
                                                                    {campaignData.suppressionListTitle?.length > 30
                                                                        ? campaignData.suppressionListTitle.substring(0, 30) + "..."
                                                                        : campaignData.suppressionListTitle}
                                                                </span>
                                                            </CustomTooltip>
                                                        </div> */}
                                                        <div className="mb-[10px] relative"> {/* Increased width from w-3/4 to w-[85%] */}
                                                            <div className="bg-[#f5f5f5] text-center text-16 font-semibold rounded-full p-[4px] text-muted w-full">
                                                                API Information
                                                            </div>
                                                        </div>
                                                        <div className="flex mb-[10px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">API Endpoint</span>
                                                        </div>
                                                        <div className="flex mb-8">
                                                            <p
                                                                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                                                                className="text-muted break-all">
                                                                {campaignData?.emailSentWebhookURL}
                                                            </p>
                                                        </div>
                                                        <div className="flex mb-[10px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px] flex items-center gap-2">API Request 
                                                            <CustomTooltip title={API_REQUEST_FORMAT_MESSAGE} placement="bottom" arrow={false}>
                                                                <HugeiconsIcon
                                                                    icon={HelpCircleIcon}
                                                                    size={18}
                                                                    color="#3A3A3A"
                                                                    strokeWidth={0.2}
                                                                />
                                                            </CustomTooltip>
                                                            </span>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            {(campaignData?.emailSentWebHookRequestBody != null) ? (
                                                                <pre className="bg-[#f5f5f5] p-3 rounded-md mt-1 text-sm font-mono whitespace-pre-wrap w-full">
                                                                    {(() => {
                                                                        try {
                                                                            // Ensure the input is a valid JSON string
                                                                            const formattedJson = JSON.stringify(JSON.parse(campaignData.emailSentWebHookRequestBody.replace(/'/g, '"')), null, 2);
                                                                            return formattedJson;
                                                                        } catch (error) {
                                                                            console.error("Invalid JSON format:", error);
                                                                            return "Error: Invalid JSON format received from API.";
                                                                        }
                                                                    })()}
                                                                </pre>
                                                            ) : (
                                                                <span>No data available</span>
                                                            )}
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* ✅ Right Section: Template Preview */}
                                                <div className="w-1/2 pl-[20px] flex flex-col items-start">
                                                    <p className="text-16 font-semibold text-muted mb-2">Template Preview</p>
                                                    <div className=" h-[545px] flex items-center justify-center relative w-full border border-[#e6ecf2] rounded-lg">
                                                        {!imageError  ? (
                                                            <img
                                                                src={`${TemplateImagePublicURL}Template/${campaignData?.templateIdentifier}/${campaignData?.templateVersion}/Template_Large.png`}
                                                                alt="Template Preview"
                                                                className="icon-hover"
                                                                onError={() => {
                                                                    setImageError(true);
                                                                    setPreviewContent('');
                                                                }}
                                                                // Hide image if it fails to load
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} // Adjust the size and style as needed
                                                            />
                                                        ): (
                                                                                                                              <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
                                                                                                                            )
                                                        }
                                                        <React.Fragment>
                                                            {previewContent === '' && (
                                                                <HugeiconsIcon
                                                                    icon={Image03Icon}
                                                                    size={50}
                                                                    color="#6B7280"
                                                                    className="block" // Show icon when image is not available
                                                                />
                                                            )}
                                                        </React.Fragment>

                                                        {/* Hover View Icon */}
                                                        <div 
                                                          className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg hover:opacity-100 transition-opacity cursor-pointer`} 
                                                          onClick={() => setIsPreviewModalOpen(true)}
                                                        >
                                                            <HugeiconsIcon
                                                                icon={ViewStrokeRounded}
                                                                size={24}
                                                                color="currentcolor"
                                                                strokeWidth={0.5}
                                                                className="cursor-pointer text-white"
                                                                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                                                onClick={() => setIsPreviewModalOpen(true)}

                                                            />
                                                        </div>
                                                        <TemplatePreview
                                                            isOpen={isPreviewModalOpen}
                                                            onClose={() => setIsPreviewModalOpen(false)}
                                                            content={campaignData?.templateContent ?? ''}
                                                            campaignType="TriggerCampaign"
                                                            campaignId={campaignData.campaignId}
                                                        />
                                                    </div>

                                                    <div className="text-sm text-gray-700 mt-3">
                                                        <span className="font-semibold text-muted" style={{ fontSize: '14px' }}>Created:</span>
                                                        <span className="font-normal text-muted" style={{ fontSize: '14px' }}> {moment(campaignData.createdOn).format('MM/DD/YYYY h:mmA')} <span style={{ fontStyle: "italic" }}> ({campaignData.createdByName})</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <Divider sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '0px' }} />

                                            <div className='flex justify-end'>
                                                <OutlineButton onClick={handleBackClick} type='rounded' color='red' width='250px'>
                                                    Trigger Email Overview
                                                </OutlineButton>
                                            </div>
                                        </React.Fragment>
                                }



                            </div>

                        </div>
                    </div>
                </div>
    )
}

export default CampaignSummary